import React from "react";
import DisplayChar from "../Components/DisplayChar";

function Characters() {
  return (
    <div>
      <DisplayChar />
    </div>
  );
}

export default Characters;
